import * as Yup from 'yup';

const NAMESPACE = 'SCHOOL';

export const ENDPOINT = 'web-apps/dashboard-school/rombel';

export const INITIAL_VALUES = {
  name: '',
  idAcademicYears: '',
  idMajor: '',
  code: '',
  idClass: '',
  idStudents: [],
  homeRoomTeacher: '',
};

export const ROMBEL_SCHEMA = Yup.object().shape({
  name: Yup.string().required('Nama Kelas harus diisi'),
  code: Yup.string().required('Kode Kelas harus diisi'),
  idAcademicYears: Yup.string().required('Tahun Ajaran harus dipilih'),
  idMajor: Yup.string().required('Jurusan harus dipilih'),
  idClass: Yup.string().required('Tingkat harus dipilih'),
});

export const FETCH_ROMBEL = `${NAMESPACE}_FETCH_ROMBEL`;
export const FETCH_STUDENT_ROMBEL = `${NAMESPACE}FETCH_STUDENT_ROMBEL`;
export const FETCH_STUDENT_NO_ROMBEL = `${NAMESPACE}FETCH_STUDENT_NO_ROMBEL`;
export const FETCH_STUDENT = `${NAMESPACE}_FETCH_STUDENT`;
